export default "__VITE_ASSET__BlU6zZuG__"